module.exports = __webpack_public_path__ + "img/empilhadeiras_pag9.10eadde1.jpg";